/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Back_To_SelectionInputs */

const de_auth_mfa_back_to_selection = /** @type {(inputs: Auth_Mfa_Back_To_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Methode wählen`)
};

/** @type {(inputs: Auth_Mfa_Back_To_SelectionInputs) => LocalizedString} */
const en_auth_mfa_back_to_selection = de_auth_mfa_back_to_selection;

/**

* @param {Auth_Mfa_Back_To_SelectionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_back_to_selection = /** @type {((inputs?: Auth_Mfa_Back_To_SelectionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Back_To_SelectionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_back_to_selection(inputs)
	return en_auth_mfa_back_to_selection(inputs)
});